module.exports = __webpack_public_path__ + "static/media/Dashboard.2f723375.svg";